import React from 'react';
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonIcon, IonLabel } from '@ionic/react';
import { logoIonic, rocket, rocketOutline, rocketSharp, thumbsUp } from 'ionicons/icons';

class Finish extends React.Component<{res: any, restart: any}> {
    constructor(props) {
      super(props);
      this.setState({title: "C'est terminé!"})
    }

    render() {
        return <>
                <IonCard>
                  <IonCardHeader>
                    <IonCardTitle><IonIcon icon={rocketSharp} size="large"></IonIcon></IonCardTitle>
                    <IonCardSubtitle><IonLabel color="success">{this.props.res}</IonLabel></IonCardSubtitle>
                  </IonCardHeader>

                  <IonCardContent>Félicitations, merci pour votre participation <IonIcon icon={thumbsUp}></IonIcon></IonCardContent>
                <IonButton onClick={this.props.restart} color="danger">Nouvelle course</IonButton>
                </IonCard>
              </>;
    }
  }

  export default Finish;